import { useMemo } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

// global scss for globally styles and fonts
import "./_fonts.scss";
import "./_global.scss";

import PublicRoute from "./Components/Routes/PublicRoute.js";
import { WEB_ROUTES } from "./constants.js";
import { baseRoute } from "./Helper";

import ProtectedLayout from "./Components/Layouts/ProtectedLayout.js";
import Account from "./Pages/Account";
import Dashboard from "./Pages/Dashboard";
// import Tournaments from "./Pages/Tournaments";
import Messages from "./Pages/Messages";
import Setting from "./Pages/Setting";
// import Profile from "./Pages/Profile";
// import PaymentMethod from "./Pages/PaymentMethod";
import { uniqueId } from "lodash";
import ProtectedRoute from "./Components/Routes/ProtectedRoute.js";
import BadgeManagementScreen from "./Pages/BadgeManagement/BadgeManagementScreen.js";
import CategoryManagementScreen from "./Pages/CategoryManagement/CategoryManagementScreen.js";
import PageManagementScreen from "./Pages/PageManagement/PageManagementScreen.js";
import PollManagementScreen from "./Pages/PollManagement/PollManagementScreen.js";
import SuggestionPollManagementScreen from "./Pages/PollManagement/SuggestionPollManagementScreen.js";
import PollRulesManagementScreen from "./Pages/PollRulesManagement/PollRulesManagementScreen.js";
import SendNotificationScreen from "./Pages/SendNotification/SendNotificationScreen.js";
import TransactionManagementScreen from "./Pages/TransactionManagement/TransactionManagementScreen.js";
import UserManagementScreen from "./Pages/UserManagement/UserManagementScreen.js";
// import TournamentManagementScreen from "./Pages/TournamentManagement/TournamentManagementScreen.js";
// import TournamentManagement from './Pages/TournamentManagement';
function App() {
  // todo: menu
  const ROUTES = useMemo(() => {
    return [
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.ACCOUNT)}
        element={
          <PublicRoute>
            <Account />
          </PublicRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.DASHBOARD}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Dashboard />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.USER_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <UserManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.CATEGORY_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <CategoryManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.TXN_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <TransactionManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.ORDER_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <OrderManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.ORDER_DETAILS}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <OrderDetailScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.PRODUCT_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <ProductManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      //
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.BADGES_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <BadgeManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.POLL_RULES_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <PollRulesManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.POLLS_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <PollManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SUGGESTION_POLLS_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <SuggestionPollManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SUPPORT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Messages />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.ADVERTISEMENT_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <AdvertisementManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      // //
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.FAQ_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <FAQManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.PAGE_MANAGEMENT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <PageManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.LEVELS_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <LevelsManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.PACKAGES_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <PackagesManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,

      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.GAME_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <GameManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.GAME_CATEGORIES_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <GameCategoriesManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.GAME_TEAMS_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <GameTeamsManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,
      // <Route
      //   key={uniqueId}
      //   exact
      //   path={WEB_ROUTES.GAME_QUESTION_MANAGEMENT}
      //   element={
      //     <ProtectedRoute>
      //       <ProtectedLayout isSearchBar={false}>
      //         <GameQuestionManagementScreen />
      //       </ProtectedLayout>
      //     </ProtectedRoute>
      //   }
      // />,

      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SEND_NOTIFICATION}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <SendNotificationScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={WEB_ROUTES.SETTING}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Setting />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
    ];
  }, []);

  return (
    <Router>
      <Routes>
        {ROUTES.map((item) => item)}
        <Route
          path={baseRoute("*")}
          element={<Navigate to={WEB_ROUTES.ACCOUNT} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
